import { idmApi } from './http';

export async function getAllRoles() {
  const response = await idmApi.get('/roles');
  return response.data.data;
}
